import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import get from 'lodash/get';

import { matchPath } from 'react-router';
import styles from './Routing.css';
import { config as routeConfig } from '../../lib/routing';
import { setGADimensions } from '../../lib/analytics';

const locationIsModal = location => get(location, 'state.modal', false);

class Routing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      location: null,
      modalBaseLocation: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { location: nextLocation } = props;
    const { location: currentLocation, modalBaseLocation } = state;

    const nextIsModal = locationIsModal(nextLocation);

    let nextModalBaseLocation = modalBaseLocation;

    if (!nextModalBaseLocation && nextIsModal) {
      nextModalBaseLocation = currentLocation;
    } else if (!nextIsModal) {
      nextModalBaseLocation = null;
    }

    return {
      location: nextLocation,
      modalBaseLocation: nextModalBaseLocation
    };
  }

  get isModal() {
    const { location } = this.state;

    return locationIsModal(location);
  }

  componentDidUpdate(prevProps) {
    const { location, setGAClientOptions, logPageView } = this.props;
    const { location: previousLocation } = prevProps;

    const previousWasModal = locationIsModal(previousLocation);

    if (location !== previousLocation) {
      setGAClientOptions({ page: location.pathname + location.search });
      logPageView();

      if (!this.isModal && !previousWasModal) {
        window.scrollTo(0, 0);
      }
    }
  }

  componentDidMount() {
    const {
      logPageView,
      userInfo,
      setGAClientOptions,
      experiments,
      userAccount,
      cookies,
      analyticsData
    } = this.props;

    if (userInfo) {
      setGADimensions({
        userInfo,
        userAccount,
        cookies,
        analyticsData,
        setGAClientOptions
      });
      setGAClientOptions({
        dimension21: Object.keys(experiments)
          .map(key => `${key}:${experiments[key]}`)
          .join(',')
      });
    }
    logPageView();
  }

  render() {
    const { location, modalBaseLocation } = this.state;

    const { component: ModalRouteComponent, ...modalRoute } = this.isModal
      ? routeConfig.find(route => matchPath(location.pathname, route))
      : {};

    const modalProps = { isModal: this.isModal, modalBaseLocation };

    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <Switch location={this.isModal ? modalBaseLocation : location}>
            {routeConfig.map(route => (
              <Route {...route} />
            ))}
          </Switch>
        </div>
        {this.isModal ? (
          <Route
            {...modalRoute}
            render={routeProps => (
              <ModalRouteComponent {...routeProps} {...modalProps} />
            )}
          />
        ) : null}
      </div>
    );
  }
}

Routing.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object,
    pathname: PropTypes.string.isRequired
  }).isRequired,
  logPageView: PropTypes.func,
  setGADimensions: PropTypes.func,
  setGAClientOptions: PropTypes.func,
  history: PropTypes.shape({
    action: PropTypes.string
  }).isRequired,
  userInfo: PropTypes.shape(),
  userAccount: PropTypes.shape(),
  cookies: PropTypes.shape(),
  analyticsData: PropTypes.shape()
};

Routing.defaultProps = {
  logPageView: () => {},
  setGAClientOptions: () => {},
  setGADimensions: () => {}
};

Routing.displayName = 'Routing';

export default Routing;
